// extracted by mini-css-extract-plugin
export const columnThumbnailContainer = "ColumnCarousel-module--column-thumbnail-container--3102u";
export const columnThumbnailImage = "ColumnCarousel-module--column-thumbnail-image--74s29";
export const columnTitle = "ColumnCarousel-module--column-title--1PkrO";
export const columnLink = "ColumnCarousel-module--column-link--3mt7D";